import { render } from "./ReportCardsView.vue?vue&type=template&id=7acdf165"
import script from "./ReportCardsView.vue?vue&type=script&lang=js"
export * from "./ReportCardsView.vue?vue&type=script&lang=js"

import "./ReportCardsView.vue?vue&type=style&index=0&id=7acdf165&lang=scss"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__